const Arabic = {
  champion: "من البطل",
  signinToAccount: "سجل الدخول الى حسابك",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  forgotPassword: "هل نسيت كلمة المرور؟",
  signin: "تسجيل دخول",
  resetPassword: "إعادة تعيين كلمة المرور",
  enterEmail: "ادخل بريدك الإلكتروني .",
  confirm: "تأكيد",
  updatePassword: "تعديل كلمة المرور",
  code: "ادخل الرمز",
  newPass: "كلمة مرور جديدة",
  confirmPass: "تأكيد كلمة المرور",
  reset: "تعديل",
  otpRequired: "ادخل رمز OTP",
  passwordMin: "يجب ان لا تقل كلمة المرور عن 3 احرف.",
  passwordRequired: "ادخل كلمة المرور.",
  passwordMatch: "يجب ان تطابق كلمة المرور.",
  confirmPasswordRequired: "قم بتأكيد كلمة المرور.",
  emailNotValid: "البريد الإلكتروني غير صالح",
  emailRequired: "ادخل بريدك الإلكتروني .",
  institutes: "المؤسسات",
  families: "العائلات",
  users: "المستخدمين",
  subscriptions: "الإشتراكات",
  title: "العنوان",
  description: "الوصف",
  displayType: "نوع العرض",
  detailed: "مفصل",
  summarized: "ملخص",
  period: "الفتره الزمنية",
  targetUser: "المستخدم المستهدف",
  institute: "مؤسسة",
  family: "عائلة",
  price: "الاسعار",
  actions: "الإجراءات",
  pricingList: "قائمة الأسعار",
  dashboard: "الرئيسية",
  insights: "الرؤى",
  pricing: "التسعيرات",
  activeUsers: "المستخدمين النشطين",
  reports: "التقارير",
  copyRights: "حقوق الملكية",
  contacts: "التواصل",
  settings: "الإعدادات",
  gifts: "الجوائز",
  tasks: "المهام",
  offers: "العروض",
  notifications: "التنبيهات",
  toAll: "إرسال للجميع",
  toMultiple: "إرسال للبعض",
  advertisements: "الإعلانات",
  createdAt: "تاريخ الإضافة",
  phoneNumber: "رقم الهاتق",
  user: "المستخدم",
  firstName: "الإسم الاول",
  midName: "الإسم الثاني",
  userEmail: "البريد الإلكتروني",
  noPhoneNumber: "لم يتم إدخال رقم الهاتف!",
  instituteUsersList: "قائمة مستخدمي المؤسسات",
  newUser: "إضافة مستخدم",
  home: "الرئيسية",
  familiesUsersList: "قائمة مستخدمي العائلات",
  search: "بحث",
  addInstituteUser: "إضافة مستخدم جديد",
  phoneRequired: "الرجاء ادخل رقم الهاتف",
  phoneNotValid: "رقم الهاتف غير صحيح",
  nameRequired: "ادخل الإسم",
  save: "حفظ",
  cancel: "إلغاء",
  editUser: "تعديل بيانات المستخدم",
  roleRequired: "اختر الدور",
  createUserSuccess: "تم إنشاء المستخدم بنجاح",
  createUserError: "فشل إنشاء المستخدم ",
  updateUserSuccess: "تم تحديث المستخدم بنجاح",
  updateUserError: "فشل تحديث المستخدم",
  emailAlreadyExsit: "البريد الإلكتروني موجود مسبقاً",
  phoneNumberAlreadyExsit: "رقم الهاتف موجود مسبقاً",
  editinstitutesUser: "تحديث بيانات المستخدم",
  genderRequired: "الرجاء تحديد النوع",
  deleteInstituteUser: "حذف مستخدم مؤسسات",
  areYouSureWantTo: "هل انت متأكد من عملية الحذف ؟",
  delete: "حذف",
  deleteUserError: "فشل الحذف",
  deleteUserSuccess: "تم الحذف بنجاح",
  userDetails: "تفاصيل المستخدم",
  userInformation: "معلومات المستخدم",
  personalDetails: "تفاصيل و معلومات المستخدم",
  b6Code: "رمز البطل",
  fullName: "الإسم كامل",
  birthDate: "تاريخ الميلاد",
  noBirthDate: "تاريخ الميلاد غير موجود",
  gender: "النوع",
  sendNotification: "إرسال تنبيه",
  characterNumber: "يجب إدخال 3 احرف على الاقل",
  titleRequired: "ادخل العنوان",
  messageRequired: "ادخل الرسالة",
  arabicTitle: "العنوان بالعربي",
  englishTitle: "العنوان بالإنجليزي",
  arabicBody: "المحتوى بالعربي",
  englishBody: "المحتوى بالإنجليزي",
  sendNotificationTo: "إرسال تنبية إلى",
  send: "إرسال",
  sendNotificationError: "فشل في إرسال التنبيه",
  sendNotificationSuccess: "تم إرسال التنبيه",
  instituteDetails: "تفاصيل المؤسسة",
  female: "انثى",
  male: "ذكر",
  select: "اختار",
  logout: "تسجيل خروج",
  newInstitutes: "المؤسسات الجديدة",
  newFamilies: "العائلات الجديدة",
  newUsers: "المستخدمين الجدد",
  amountPerMonth: "المبلغ المتحصل خلال شهر",
  newAdded: "الجدد",
  editfamiliesUser: "تحديث بيانات المستخدم",
  name: "الإسم",
  address: "العنوان",
  admin: "المشرف",
  details: "التفاصيل",
  englishName: "الإسم بالإنجليزي",
  arabicName: "الإسم بالعربي",
  id: "رمز التعريف",
  grades: "المراحل الدراسية",
  gradename: "اسم المرحلة الدراسية",
  teachers: "المعلمين",
  classRooms: "الفصول الدراسية",
  classRoomsDetails: "تفاصيل الفصل الدراسي",
  profile: "الصورة",
  students: "الطلاب",
  subject: "المادة",
  homeWorks: "الواجبات المنزلية",
  from: "من",
  to: "إلى",
  status: "الحالة",
  teacher: "الاستاذ",
  student: "الطالب",
  studentNoteDetails: "تفاصيل ملاحظات الطالب",
  institutesList: "قائمة المؤسسات",
  familiesList: "قائمة العائلات",
  familyMembers: "أفراد العائلة",
  familyName: "إسم العائلة",
  relevance: "العلاقة",
  noRelevance: "لم يتم تحديد العلاقة",
  defaultSettings: "الإعدادات الإفتراضية",
  defaultGiftsList: "قائمة الجوائز الافتراضية",
  newGift: "إضافة جائزه",
  addNewGiftSuccess: "تمت إضافة الهدية بنجاح",
  addNewGiftError: "فشل إضافة الهدية",
  editGift: "تحديث الجائزة",
  editGiftSuccess: "تم تحديث الهدية بنجاح",
  editGiftError: "فشل تحديث الهدية  ",
  deleteGift: "حذف الجائزة",
  deleteGiftSuccess: "تم الحذف بنجاح",
  deleteGiftError: "فشل الحذف ",
  photo: "الصورة",
  targetPoints: "رقم الفائز",
  accountType: "نوع الحساب",
  enabled: "مفعل",
  yes: "نعم",
  no: "لا",
  uploadImage: "تحميل الصورة",
  arabicDescription: "الوصف بالعربي",
  englishDescription: "الوصف بالإنجليزي",
  remove: "حذف",
  defaultTasksList: "قائمة المهام الافتراضية",
  newTask: "إضافة مهمة",
  addNewTaskSuccess: "تمت إضافة المهمة بنجاح",
  addNewTaskError: "فشل في العملية",
  editTask: "تحديث المهمة",
  editTaskSuccess: "تم تحديث المهمة بنجاح",
  editTaskError: "فشل تحديث المهمة  ",
  deleteTask: "حذف المهمة",
  deleteTaskSuccess: "تم الحذف بنجاح",
  deleteTaskError: "فشل الحذف ",
  ads: "الإعلانات",
  url: "رابط الإعلان",
  updateAdsSuccess: "تم التعديل بنجاح",
  updateAdsError: "فشل في العملية",
  sendNotificationToAll: "إرسال تنبية لكل المستخدمين",
  sendNotificationToMulti: "إرسال تنبية لبعض المستخدمين",
  selectUsersRequired: "إختار المستخدمين",
  selectUsers: "إختار المستخدمين المستهدفين",
  subscriptionsAndOffers: "الإشتراكات و العروض",
  subscriptionsList: "قائمة الإشتراكات",
  subscribed: "مشترك",
  expired: "غير مشترك",
  returnHome: "الرجوع للصفحة الرئيسية",
  sorryThisPageNotFound: "نأسف هذه الصفحة غير موجودة",
  pageNotFound: "الصفحة غير موجودة",
  newPricing: "إضافة تسعيرة",
  appleProductIdRequired: "رقم معرف ابل مطلوب",
  priceRequired: "يجب إدخال السعر",
  periodRequired: "يجب إدخال الفترة الزمنية",
  arabicDescriptionRequired: "ادخل وصف التسعير بالعربية",
  englishDescriptionRequired: "ادخل وصف التسعير بالإنجليزية",
  accountTypeRequired: "ادخل نوع الحساب",
  enabledRequired: "ادخل الحالة",
  targetPointsRequired: "ادخل رفم الفائز",
  intervalRequired: "ادخل الوحدة الزمنية",
  targetUserRequired: "ادخل الفئة المستهدفة",
  summarizedRequired: "ادخل نوع العرض",
  specialRequired: "ادخل نوع التصميم",
  appleProductId: "رقم معرف ابل",
  units: "الوحدات",
  interval: "الوحدة الزمنية",
  specialDesign: "تصميم مميز",
  normalDesign: "تصميم عادي",
  designType: "نوع التصميم",
  addPricingSuccess: "تمت إضافة التسعير بنجاح",
  addPricingError: "فشل إضافة التسعير ",
  updatePricing: "تحديث التسعيرة",
  updatePricingSuccess: "تم تحديث التسعير بنجاح",
  updatePricingError: "فشل في العملية",
  deletePricing: "حذف التسعيرة",
  deletePricingError: "فشل الحذف ",
  deletePricingSuccess: "تم الحذف بنجاح",
  month: "شهر",
  year: "سنة",
  offersList: "قائمة العروض",
  newOffer: "إضافة عرض",
  addOfferSuccess: "تمت إضافة العرض بنجاح",
  addOfferError: "فشل في العملية",
  editOffer: "تحديث العرض",
  updateOfferSuccess: "تم تحديث العرض بنجاح",
  updateOfferError: "فشل في العملية",
  deleteOffer: "حذف العرض",
  deleteOfferSuccess: "تم الحذف بنجاح",
  deleteOfferError: "فشل في العملية",
  offerType: "نوع العرض",
  discount: "الخصم",
  extraUnit: "وحدات إضافية",
  typeRequired: "نوع العرض مطلوب",
  discountRequired: "قيمة التخفيض مطلوية",
  rangeRequired: "قيمة الوحدات الإضافية مطلوبة",
  fromRequired: "تاريخ بداية العرض مطلوب",
  toRequired: "تاريخ نهاية العرض مطلوب",
  pricingRequired: "اختر التسعيرة",
  telegram: "رابط تلقرام",
  whatsApp: "رقم Whatsapp",
  facebook: "فيسبوك",
  twitter: "تويتر",
  instagram: "إنستقرام",
  website: "رابط الموقع",
  instructions: "رابط صفحة التعليمات",
  updateContactError: "فشل في العملية",
  updateContactSuccess: "تم التعديل بنجاح",
  yearRequired: "ادخل شنة النشر",
  updateRightsError: "فشل في العملية",
  updateRightsSuccess: "تم التعديل بنجاح",
  subscriptionsReport: "تقرير الاشتراكات",
  pricingReport: "تقرير التسعيرات",
  familiesReport: "تقريرالعائلات",
  activeUsersReport: "تقرير المستخدمين النشطين",
  institutesReport: "تقرير المؤسسات",
  expiredSubscriptions: "الإشتراكات المنتهية",
  newSubscriptions: "الإشتراكات الجديدة",
  selectYear: "اختر السنة",
  selectMonth: "اختر الشهر",
  selectDayOrMonth: "اختر يوم او شهر لعرض البيانات",
  showMonthSubscriptions: "عرض بيانات الاشتراك في شهر:",
  showDaySubscriptions: "عرض بيانات الاشتراك في يوم:",
  subscriptionDate: "تاريخ الاشتراك",
  accountName: "إسم الحساب",
  notFound: "لا يوجد",
  familiesPricings: "تسعيرات العائلات",
  institutesPricings: "تسعيرات المؤسسات",
  newRegistrations: "المستخدمين الجدد",
  showMonthInstitutes: "عرض بيانات المؤسسات في شهر:",
  showDayInstitutes: "عرض بيانات المؤسسات في يوم:",
  showMonthFamilies: "عرض بيانات العائلات في شهر:",
  showDayFamilies: "هعرض بيانات العائلات في يوم:",
  showMonthActiveUsers: "عرض بيانات المستخدمين النشطين في شهر:",
  showDayActiveUsers: "هعرض بيانات المستخدمين النشطين في يوم:",
  EnableWhatsAppMessage: "تفعيل رسائل الواتساب",
  WhatsAppMessage: "رسائل الواتساب",
  changesSaved: "تم حفظ التغييرات",
};

export default Arabic;
